import { PRIVATE_ADMIN_FORM_PERMISSION, PRIVATE_ADMIN_LIST_PERMISSIONS } from "../Constants/PathsConstant";
import FormPermissionView from "../Views/FormPermissionView";
import TablePermissionView from "../Views/TablePermissionView";

export const PermissionRouter = [
  {
    path: PRIVATE_ADMIN_LIST_PERMISSIONS,
    element: <TablePermissionView />,
    children: [
      
    ]
  },
  {
    path: PRIVATE_ADMIN_FORM_PERMISSION + '/:id',
    element: <FormPermissionView />,
    children: [
      
    ]
  }
];